import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/rules")({
  component: Rule,
});

function Rule() {
  return <Outlet />;
}
